import type { Product, Variant } from '@scayle/storefront-nuxt'

export const useCareProducts = (product: Ref<Product | null>) => {
  const variantsSortedByPrice: Ref<Variant[]> = computed(() =>
    (product?.value?.variants ?? []).sort(
      (a, b) => a.price.withTax - b.price.withTax,
    ),
  )

  const cheapestVariant = computed(() => variantsSortedByPrice.value?.[0])

  const calculatePackageDiscountPercentage = (variant: Variant) => {
    if (
      variant.id !== cheapestVariant.value.id &&
      variant.price.reference &&
      cheapestVariant.value.price.reference
    ) {
      const discount =
        Math.abs(
          cheapestVariant.value.price.reference.withTax
            ? 1 -
                variant.price.reference.withTax /
                  cheapestVariant.value.price.reference.withTax
            : 0,
        ) * 100

      return discount ? discount.toFixed() : 0
    }

    return 0
  }

  const packageUnits = computed(() => {
    return variantsSortedByPrice.value.map((variant: any, key: number) => ({
      key,
      variantId: variant.id,
      label: getFirstAttributeLabel(
        variant.attributes,
        'packingTypeDescription',
      ),
      pricePerUnit: variant.price.reference?.withTax,
      discount: calculatePackageDiscountPercentage(variant),
      bapiPrice: variant.price,
      lowestPrice: getLowestPriorPrice(variant.price, variant.lowestPriorPrice),
      isSoldOut: !isVariantAvailable(product, variant),
    }))
  })

  return {
    cheapestVariant,
    packageUnits,
  }
}
